import React from 'react'
import { Col } from 'react-bootstrap'
import {useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import ModalImage from 'react-modal-image'
import styled from 'styled-components'

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  width: 100%;
`;


const KeelLayingGallery = () => {
    const query = useStaticQuery(graphql`
    {
        allContentfulGallery (filter: {galleryTitle: {eq: "Pressure Hull"}}) {
          edges {
            node {
              images {
                description
                fluid (maxWidth: 2000) {
                  srcWebp
                }
              }
            }
          }
        }
      }
  `)
  const photos = query.allContentfulGallery.edges[0].node.images;
  console.log(photos)

    return (
      <div>
      { photos.map((photo) => {
        return (
          <Col>
            <div>
            <img src={photo.fluid.srcWebp} alt="USS IDAHO Keel Laying" className="rounded" style={{width: '100%', height: '100%'}}/>            
            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
              <p><strong>{photo.description}</strong></p>
              <p style={{textAlign: 'right'}}>Photo Courtesy of General Dynamics Electric Boat</p>
            </div>
            </div>
          </Col>
        )
      })}
      {/* <GalleryGrid>
              { photos.map((photo) => {
       return (         
           <ModalImage
            hideDownload
            hideZoom 
            small={photo.fluid.srcWebp}
            large={photo.fluid.srcWebp}
            alt={photo.description}
            className="rounded"
           />
          
       )
     }) }
     </GalleryGrid> */}
     </div>
    )
}

export default KeelLayingGallery